export default "__VITE_ASSET__83f6d27b__"